/**
 * Session-Only Mode Warning Component
 * 
 * Displays a warning banner when localStorage is unavailable
 * and the app is running in session-only mode.
 */

import { useOutletAuth } from '../lib/auth/OutletAuthProvider';

export function SessionOnlyWarning() {
  const { sessionOnlyMode } = useOutletAuth();

  if (!sessionOnlyMode) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-white px-4 py-2 text-center text-sm font-semibold shadow-lg">
      <div className="flex items-center justify-center gap-2">
        <span>⚠️</span>
        <span>
          Session-Only Mode: Authentication will not persist after closing the app.
          Please enable browser storage for full functionality.
        </span>
      </div>
    </div>
  );
}
